import { generateBookingReference, validateBookingData } from './bookingUtils';

export interface BookingData {
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  serviceType: string;
  appointmentDate: Date;
  appointmentTime: string;
  paymentAmount: number;
  customerNotes?: string;
}

export async function createBookingCheckoutSession(bookingData: BookingData) {
  // Stripe integration removed - this function is disabled
  throw new Error('Stripe integration has been removed. Please configure Stripe to enable bookings.');
}

export async function getBookingByReference(bookingReference: string) {
  // This function can still work without Stripe for viewing bookings
  const { VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY } = import.meta.env;
  
  try {
    const response = await fetch(`${VITE_SUPABASE_URL}/functions/v1/get-booking`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${VITE_SUPABASE_ANON_KEY}`
      },
      body: JSON.stringify({ booking_reference: bookingReference }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to retrieve booking');
    }

    return data.booking;
  } catch (error) {
    console.error('Error retrieving booking:', error);
    throw error;
  }
}